document.addEventListener("touchstart", () => {}, { passive: true });
